import React, { useState, useContext } from "react";
import { auth, signInWithEmailAndPassword } from "../../index";
import axios from "axios";
import { UserContext } from "../../UserContext";
import "./styles.css";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import loginImage from "../../assets/Login/login.png";
import { useTranslation } from "react-i18next";
import { useNavigate, Link } from "react-router-dom";
import classNames from "classnames";
import PhoneInput from "react-phone-number-input";
import ar from "react-phone-number-input/locale/ar";
import en from "react-phone-number-input/locale/en";
import "react-phone-number-input/style.css";

const Login = ({ setIsLoggedIn }) => {
  const [t, i18n] = useTranslation();
  const [loginMethod, setLoginMethod] = useState("email"); // 'email' or 'phone'
  const [email, setEmail] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [password, setPassword] = useState("");
  const { setUserData, setToken, setShowSubscriptionPlans } =
    useContext(UserContext);
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState("");
  const navigate = useNavigate();
  const labels = i18n.language === "ar" ? ar : en;

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    setError("");

    if (loginMethod === "email") {
      // Email Login Logic
      try {
        const userCredential = await signInWithEmailAndPassword(
          auth,
          email,
          password
        );
        const user = userCredential.user;
        const token = await user.getIdToken();
        setToken(token);

        // Login - FCM token registration will be handled by NotificationContext after login
        const response = await axios.post(
          "api/auth/newLogin",
          { firebaseId: user.uid },
          { headers: { Authorization: `${token}` } }
        );
        // temp user data for testing
        // const response = {
        //   data: {
        //     status: 200,
        //     message: "User logged in successfully.",
        //     items: [
        //       {
        //         Role: {
        //           id: 1,
        //           tenantId: null,
        //           nameEn: "Manager",
        //           nameAr: "مدير",
        //           createTs: "2023-06-05T19:31:51Z",
        //           updateTs: "2024-05-27T18:49:21Z",
        //         },
        //         EmployeeRoles: [
        //           {
        //             id: 283,
        //             employeeId: 267,
        //             roleId: 1,
        //             scope: "tenant",
        //             tenantId: 134,
        //             farmId: null,
        //             fieldId: null,
        //             createTs: "2025-01-20T13:36:14Z",
        //             updateTs: "2025-01-20T13:36:14Z",
        //           },
        //         ],
        //         RolePermissions: [
        //           {
        //             id: 1,
        //             roleId: 1,
        //             module: "Fields",
        //             fullAccess: true,
        //             add: true,
        //             delete: true,
        //             view: true,
        //             edit: true,
        //             createTs: "2024-05-27T18:49:53Z",
        //             updateTs: "2024-05-27T18:49:53Z",
        //           },
        //           {
        //             id: 2,
        //             roleId: 1,
        //             module: "Tasks",
        //             fullAccess: true,
        //             add: true,
        //             delete: true,
        //             view: true,
        //             edit: true,
        //             createTs: "2024-05-27T18:49:53Z",
        //             updateTs: "2024-05-27T18:49:53Z",
        //           },
        //           {
        //             id: 3,
        //             roleId: 1,
        //             module: "Tasks List",
        //             fullAccess: true,
        //             add: true,
        //             delete: true,
        //             view: true,
        //             edit: true,
        //             createTs: "2024-05-27T18:49:53Z",
        //             updateTs: "2024-05-27T18:49:53Z",
        //           },
        //           {
        //             id: 4,
        //             roleId: 1,
        //             module: "Issues",
        //             fullAccess: true,
        //             add: true,
        //             delete: true,
        //             view: true,
        //             edit: true,
        //             createTs: "2024-05-27T18:49:53Z",
        //             updateTs: "2024-05-27T18:49:53Z",
        //           },
        //           {
        //             id: 5,
        //             roleId: 1,
        //             module: "Inventory",
        //             fullAccess: true,
        //             add: true,
        //             delete: true,
        //             view: true,
        //             edit: true,
        //             createTs: "2024-05-27T18:49:53Z",
        //             updateTs: "2024-05-27T18:49:53Z",
        //           },
        //           {
        //             id: 6,
        //             roleId: 1,
        //             module: "Products",
        //             fullAccess: true,
        //             add: true,
        //             delete: true,
        //             view: true,
        //             edit: true,
        //             createTs: "2024-05-27T18:49:53Z",
        //             updateTs: "2024-05-27T18:49:53Z",
        //           },
        //           {
        //             id: 7,
        //             roleId: 1,
        //             module: "Online Support",
        //             fullAccess: true,
        //             add: true,
        //             delete: true,
        //             view: true,
        //             edit: true,
        //             createTs: "2024-05-27T18:49:53Z",
        //             updateTs: "2024-05-27T18:49:53Z",
        //           },
        //           {
        //             id: 8,
        //             roleId: 1,
        //             module: "Farms",
        //             fullAccess: false,
        //             add: true,
        //             delete: false,
        //             view: true,
        //             edit: false,
        //             createTs: "2024-05-27T18:49:53Z",
        //             updateTs: "2024-06-27T09:21:22Z",
        //           },
        //           {
        //             id: 9,
        //             roleId: 1,
        //             module: "Invoices",
        //             fullAccess: true,
        //             add: true,
        //             delete: true,
        //             view: true,
        //             edit: true,
        //             createTs: "2024-05-27T18:49:53Z",
        //             updateTs: "2024-05-27T18:49:53Z",
        //           },
        //           {
        //             id: 10,
        //             roleId: 1,
        //             module: "Expenses",
        //             fullAccess: true,
        //             add: true,
        //             delete: true,
        //             view: true,
        //             edit: true,
        //             createTs: "2024-05-27T18:49:53Z",
        //             updateTs: "2024-05-27T18:49:53Z",
        //           },
        //           {
        //             id: 11,
        //             roleId: 1,
        //             module: "Incomes",
        //             fullAccess: true,
        //             add: true,
        //             delete: true,
        //             view: true,
        //             edit: true,
        //             createTs: "2024-05-27T18:49:53Z",
        //             updateTs: "2024-05-27T18:49:53Z",
        //           },
        //           {
        //             id: 12,
        //             roleId: 1,
        //             module: "Suppliers/Clients",
        //             fullAccess: true,
        //             add: true,
        //             delete: true,
        //             view: true,
        //             edit: true,
        //             createTs: "2024-05-27T18:49:53Z",
        //             updateTs: "2024-05-27T18:49:53Z",
        //           },
        //           {
        //             id: 13,
        //             roleId: 1,
        //             module: "Employees",
        //             fullAccess: true,
        //             add: true,
        //             delete: true,
        //             view: true,
        //             edit: true,
        //             createTs: "2024-05-27T18:49:53Z",
        //             updateTs: "2024-05-27T18:49:53Z",
        //           },
        //           {
        //             id: 14,
        //             roleId: 1,
        //             module: "Assets",
        //             fullAccess: true,
        //             add: true,
        //             delete: true,
        //             view: true,
        //             edit: true,
        //             createTs: "2024-05-27T18:49:53Z",
        //             updateTs: "2024-05-27T18:49:53Z",
        //           },
        //           {
        //             id: 15,
        //             roleId: 1,
        //             module: "Assets Requests",
        //             fullAccess: true,
        //             add: true,
        //             delete: true,
        //             view: true,
        //             edit: true,
        //             createTs: "2024-05-27T18:49:53Z",
        //             updateTs: "2024-05-27T18:49:53Z",
        //           },
        //           {
        //             id: 16,
        //             roleId: 1,
        //             module: "Reports",
        //             fullAccess: true,
        //             add: true,
        //             delete: true,
        //             view: true,
        //             edit: true,
        //             createTs: "2024-05-27T18:49:53Z",
        //             updateTs: "2024-07-30T02:36:44Z",
        //           },
        //           {
        //             id: 17,
        //             roleId: 1,
        //             module: "Robot Data",
        //             fullAccess: false,
        //             add: false,
        //             delete: false,
        //             view: true,
        //             edit: false,
        //             createTs: "2024-05-27T18:49:53Z",
        //             updateTs: "2024-06-27T09:21:56Z",
        //           },
        //           {
        //             id: 18,
        //             roleId: 1,
        //             module: "User Tracking",
        //             fullAccess: false,
        //             add: false,
        //             delete: false,
        //             view: true,
        //             edit: false,
        //             createTs: "2024-05-27T18:49:53Z",
        //             updateTs: "2024-06-27T09:22:12Z",
        //           },
        //           {
        //             id: 19,
        //             roleId: 1,
        //             module: "Tracked User",
        //             fullAccess: false,
        //             add: false,
        //             delete: false,
        //             view: false,
        //             edit: false,
        //             createTs: "2024-05-27T18:49:53Z",
        //             updateTs: "2024-06-27T09:22:24Z",
        //           },
        //           {
        //             id: 229,
        //             roleId: 1,
        //             module: "Daily Affairs",
        //             fullAccess: true,
        //             add: true,
        //             delete: true,
        //             view: true,
        //             edit: true,
        //             createTs: "2024-06-25T02:48:29Z",
        //             updateTs: "2024-06-27T09:04:21Z",
        //           },
        //           {
        //             id: 351,
        //             roleId: 1,
        //             module: "Dashboard",
        //             fullAccess: true,
        //             add: false,
        //             delete: false,
        //             view: false,
        //             edit: false,
        //             createTs: "2025-02-20T07:46:34Z",
        //             updateTs: "2025-02-20T07:47:19Z",
        //           },
        //           {
        //             id: 382,
        //             roleId: 1,
        //             module: "Notifications",
        //             fullAccess: true,
        //             add: false,
        //             delete: false,
        //             view: false,
        //             edit: false,
        //             createTs: "2025-02-20T07:50:15Z",
        //             updateTs: "2025-02-20T07:50:23Z",
        //           },
        //           {
        //             id: 413,
        //             roleId: 1,
        //             module: "HR Financial",
        //             fullAccess: true,
        //             add: false,
        //             delete: false,
        //             view: false,
        //             edit: false,
        //             createTs: "2025-02-20T07:50:46Z",
        //             updateTs: "2025-02-20T07:50:54Z",
        //           },
        //           {
        //             id: 498,
        //             roleId: 1,
        //             module: "Labor",
        //             fullAccess: true,
        //             add: true,
        //             delete: true,
        //             view: true,
        //             edit: true,
        //             createTs: "2025-07-14T02:29:56Z",
        //             updateTs: "2025-07-14T02:29:56Z",
        //           },
        //         ],
        //         Tenant: {
        //           id: 134,
        //           name: "Rana",
        //           currency: "EGP",
        //           isSubscribed: false,
        //           subscribedFrom: null,
        //           subscribedTo: null,
        //           isDeleted: false,
        //           createTs: "2025-01-20T13:36:14Z",
        //           updateTs: "2025-02-13T12:27:14Z",
        //           companyLogo:
        //             "https://egrocare-images.s3.amazonaws.com/tenants/134/logo14e8b0b8-a714-4674-891d-b9bb9fbd74e9.jpg",
        //           companyName: "ra",
        //           contactPhone: "123456789",
        //           email: "r@gmail.com",
        //           address: "address",
        //           location: "37.42159026234797,-122.08682857453823",
        //           taxId: "526",
        //           registrationNumber: "54564",
        //           totalAcreage: 31546,
        //         },
        //         User: {
        //           id: 210,
        //           firebaseId: "lbe51gOHwTaYIuay8kozWXhBjE53",
        //           roleId: 1,
        //           tenantId: 134,
        //           username: "Rana",
        //           email: "rana.dev@gmail.com",
        //           phoneNumber: "",
        //           createTs: "2025-01-20T13:36:14Z",
        //           updateTs: "2025-01-20T13:36:14Z",
        //         },
        //         Employee: {
        //           id: 267,
        //           userId: 210,
        //           tenantId: 134,
        //           supervisorId: null,
        //           farmId: 211,
        //           username: "Rana",
        //           basicSalary: 0,
        //           roles: [
        //             {
        //               id: 1,
        //               tenantId: null,
        //               nameEn: "Manager",
        //               nameAr: "مدير",
        //               createTs: "2023-06-05T19:31:51Z",
        //               updateTs: "2024-05-27T18:49:21Z",
        //             },
        //           ],
        //           createTs: "2025-01-20T13:36:14Z",
        //           updateTs: "2025-08-04T14:16:11Z",
        //           accountType: "permanent",
        //           accountSpeciality: null,
        //           rate: null,
        //           rateType: null,
        //           lastVisit: 1754316968646,
        //           hasLogin: true,
        //         },
        //         Farm: {
        //           id: 211,
        //           tenantId: 134,
        //           name: "Egrobots",
        //           location: "Alexandria",
        //           size: null,
        //           type: "soil",
        //           createTs: "2025-01-20T13:36:14Z",
        //           updateTs: "2025-01-20T13:36:14Z",
        //         },
        //         UserTokens: [
        //           {
        //             tokenId: 69,
        //             userId: 210,
        //             deviceId: "8ce2c1b160a083bc",
        //             fcmToken:
        //               "cUiWSGJMQMCA7SWAVi3-uJ:APA91bHiAqsq2EUrfphmMBh4gfwzOEmndr6ylZSgjWJ6hvWalRex0Uu9h45ZYvyUrjMY4hGJ_jAERymtE4i6S3ap5ObWQIvBumvnZBFGiUxevIo_vSDzjjI",
        //             createdAt: null,
        //             updatedAt: "2025-03-12T14:56:48.757949",
        //             deviceLanguage: "ar",
        //           },
        //         ],
        //       },
        //     ],
        //     totalCount: 0,
        //     timestamp: "2025-08-05T12:20:44.805+00:00",
        //   },
        //   status: 200,
        //   statusText: "",
        //   headers: {
        //     "cache-control": "no-cache, no-store, max-age=0, must-revalidate",
        //     "content-type": "application/json",
        //     expires: "0",
        //     pragma: "no-cache",
        //   },
        //   config: {
        //     transitional: {
        //       silentJSONParsing: true,
        //       forcedJSONParsing: true,
        //       clarifyTimeoutError: false,
        //     },
        //     adapter: ["xhr", "http"],
        //     transformRequest: [null],
        //     transformResponse: [null],
        //     timeout: 0,
        //     xsrfCookieName: "XSRF-TOKEN",
        //     xsrfHeaderName: "X-XSRF-TOKEN",
        //     maxContentLength: -1,
        //     maxBodyLength: -1,
        //     env: {},
        //     headers: {
        //       Accept: "application/json, text/plain, */*",
        //       "Content-Type": "application/json",
        //       Authorization:
        //         "eyJhbGciOiJSUzI1NiIsImtpZCI6IjJiN2JhZmIyZjEwY2FlMmIxZjA3ZjM4MTZjNTQyMmJlY2NhNWMyMjMiLCJ0eXAiOiJKV1QifQ.eyJpc3MiOiJodHRwczovL3NlY3VyZXRva2VuLmdvb2dsZS5jb20vZWdyby1jYXJlLWRldiIsImF1ZCI6ImVncm8tY2FyZS1kZXYiLCJhdXRoX3RpbWUiOjE3NTQzOTY0NDMsInVzZXJfaWQiOiJsYmU1MWdPSHdUYVlJdWF5OGtveldYaEJqRTUzIiwic3ViIjoibGJlNTFnT0h3VGFZSXVheThrb3pXWGhCakU1MyIsImlhdCI6MTc1NDM5NjQ0MywiZXhwIjoxNzU0NDAwMDQzLCJlbWFpbCI6InJhbmEuZGV2QGdtYWlsLmNvbSIsImVtYWlsX3ZlcmlmaWVkIjpmYWxzZSwiZmlyZWJhc2UiOnsiaWRlbnRpdGllcyI6eyJlbWFpbCI6WyJyYW5hLmRldkBnbWFpbC5jb20iXX0sInNpZ25faW5fcHJvdmlkZXIiOiJwYXNzd29yZCJ9fQ.DCZqBdsa0VkdexsINA9ur5ZRQ9rv9w5fnCs5Lts-Di5QhFbUabXd6pv_1Mi4h_vsigCXfb9ESACJi5-axaB1Xj5BEDaw1-JTy8-fQxB1mcu-RibWXGNM-0sYj7uF9ov_TZdbxbcQQwqxqIkXN6NoUbLM64rdHpIKY3Kxl-ULJi0ZTWjrIU1Fw7sZl1F9tUYPmqbzqmV2owM-jgJOMXLjJvNBYajB-LvKngWxxM6nRb7eoTfZhE0sSwPtM1gyif7oBBCAz80YBgEnWSDFbHDZcyAxWmeZzci0L_5ODFW3uR7NzalJMgkNoQfjdvXZqNj91DM1PlyFY8eDYwJEg2j-5Q",
        //     },
        //     baseURL: "http://34.226.212.12/egrocare-api/egrocare/",
        //     method: "post",
        //     url: "api/auth/newLogin",
        //     data: '{"firebaseId":"lbe51gOHwTaYIuay8kozWXhBjE53"}',
        //   },
        //   request: {},
        // };
        setUserData(response.data.items[0]);
        setIsLoggedIn(true);
        const isSubscribed = response.data.items[0].Tenant.isSubscribed;
        if (!isSubscribed) {
          setShowSubscriptionPlans(true);
        }
        navigate("/dashboard");
      } catch (error) {
        setError(t("Invalid email or password"));
        console.error("Error during email login:", error);
      }
    } else {
      try {
        const findUserResponse = await axios.get(
          `/api/user/findByPhoneNumber/${phoneNumber}`
        );

        if (
          !findUserResponse.data.items ||
          findUserResponse.data.items.length === 0
        ) {
          setError(t("This phone number is not registered."));
          return;
        }

        const userEmail = findUserResponse.data.items[0].email;
        if (!userEmail) {
          setError(
            t("No email is associated with this phone number. Cannot log in.")
          );
          return;
        }

        const userCredential = await signInWithEmailAndPassword(
          auth,
          userEmail,
          password
        );
        const user = userCredential.user;
        const token = await user.getIdToken();
        setToken(token);

        // Login - FCM token registration will be handled by NotificationContext after login
        const loginResponse = await axios.post(
          "/api/auth/newLogin",
          { firebaseId: user.uid },
          { headers: { Authorization: token } }
        );
        setUserData(loginResponse.data.items[0]);
        setIsLoggedIn(true);
        const isSubscribed = loginResponse.data.items[0].Tenant.isSubscribed;
        if (!isSubscribed) {
          setShowSubscriptionPlans(true);
        }
        navigate("/dashboard");
      } catch (error) {
        // EDITED: This is the enhanced logging and error handling block
        console.error("--- DETAILED LOGIN ERROR ---", error); // This will print the full error object

        if (error.response) {
          // This indicates an error from the axios API call (your backend)
          console.error("Backend Response Error Data:", error.response.data);
          if (error.response.status === 404) {
            setError(t("This phone number is not registered."));
          } else if (error.response.status === 500) {
            setError(t("A server error occurred. Please contact support."));
          } else {
            setError(t("An API error occurred. Please try again."));
          }
        } else if (error.code) {
          // This indicates an error from Firebase
          if (
            error.code === "auth/wrong-password" ||
            error.code === "auth/invalid-credential"
          ) {
            setError(t("Invalid phone number or password."));
          } else if (error.code === "auth/user-not-found") {
            setError(
              t("This user account does not seem to exist in Firebase.")
            );
          } else {
            setError(t("An authentication error occurred."));
          }
        } else {
          // This is a generic error (e.g., network, CORS)
          setError(t("An unexpected error occurred. Please try again."));
        }
      }
    }
  };

  const handleMethodChange = (method) => {
    setLoginMethod(method);
    setError(""); // Clear errors when switching tabs
    setEmail("");
    setPhoneNumber("");
    setPassword("");
    setShowPassword(false);
  };

  return (
    <div className="page-container">
      <div className="sign-in-container">
        <h1 className="header">{t("Sign In")}</h1>

        {/* --- Login Method Tabs --- */}
        <div className="login-method-tabs">
          <button
            className={`tab-btn ${loginMethod === "email" ? "active" : ""}`}
            onClick={() => handleMethodChange("email")}
          >
            {t("Email")}
          </button>
          <button
            className={`tab-btn ${loginMethod === "phone" ? "active" : ""}`}
            onClick={() => handleMethodChange("phone")}
          >
            {t("Phone Number")}
          </button>
        </div>

        <form onSubmit={handleLogin} className="form">
          {loginMethod === "email" ? (
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder={t("Email")}
              className="login-input-field"
            />
          ) : (
            <div className="phone-input-wrapper">
              <PhoneInput
                international
                placeholder={t("Phone Number")}
                defaultCountry="EG"
                value={phoneNumber}
                onChange={setPhoneNumber}
                labels={labels}
                countryCallingCodeEditable={false}
                className="login-phone-input"
              />
            </div>
          )}

          <div
            className={`password-container ${
              error ? "error-margin" : "no-error-margin"
            }`}
          >
            <input
              type={showPassword ? "text" : "password"}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder={t("Password")}
              className="password-input"
            />
            <span
              className={classNames("password-toggle-icon", {
                "password-toggle-icon-ar": i18n.language === "ar",
                "password-toggle-icon-en": i18n.language === "en",
              })}
              onClick={togglePasswordVisibility}
            >
              {showPassword ? <FaEyeSlash /> : <FaEye />}
            </span>
          </div>
          {/* Hide Forget Password Feature */}
          <div className="forgot-password-container">
            <Link to="/forgot-password" className="forgot-password-link">
              {t("Forgot password?")}
            </Link>
          </div>
          {error && <div className="error-message">{error}</div>}
          <button className="signin-btn" type="submit">
            {t("Sign In")}
          </button>
          <Link to="/signup" className="signup-btn">
            {t("Create a new account")}
          </Link>
        </form>
      </div>
      <div className="image-container">
        <img src={loginImage} alt="Sign In" className="sign-in-image" />
      </div>
    </div>
  );
};

export default Login;
